import React from "react";
import Select from "react-select";
import SimpleReactValidator from "simple-react-validator";
import FileUpload from "components/Upload/FileUpload";
import ImagePreview from "components/Upload/ImagePreview";
import {themeCSSConstants} from "redux/constant/themeCSS";
import ToggleButton from "react-toggle-button";
import {helperFunctions as HF} from "../../../../helper/helperFunctions";
import {customSelectStyles} from "../../../ThemeComponents/selectStyles";
import defaultImage from "assets/img/default.jpg";
import {listService} from "../../../../services/lists";

class AddEditTagLayoutForm extends React.Component {
    constructor(props) {
        super(props);
        this.valitdatorList = new SimpleReactValidator();
        this.state = {
            tag: {
                ...this.props.tagProp,
            },
            tagObject: this.props.tagObject,
            submitted: false,
            formType: this.props.formTypePro || "",
            allowedFormatsStringMime: "image/jpeg, image/png",
            allowedFormatsStringExt: "jpg, png",
            product_filters: [],
        };
        this.handleSubmitForm = this.handleSubmitForm.bind(this);
        this.getFiltersList();
    }

    openAddNewTagForm = () => {
        this.props.returnState({
            tagTypeAddModal: true
        });
    };

    getOptions() {
        if (this.props.tagtypesProp === undefined) {
            return [];
        }
        return this.props.tagtypesProp.map(({id, title}) => ({
            value: id,
            label: title
        }));
    }

    onChange = e => {
        this.setState({
            tag: {
                ...this.state.tag,
                [e.target.name]: e.target.value
            }
        });
    };

    onBrandChange = e => {
        this.setState({
            tag: {
                ...this.state.tag,
                tag_type: e.value
            }
        });
    };

    setResourceFile = (key, value) => {
        this.setState({
            tag: {...this.state.tag, image: value}
        });
    };

    changeFlag = (toggle, name) => {
        this.setState({
            tag: {
                ...this.state.tag,
                [name]: !toggle
            }
        });
    };

    async getFiltersList() {
        try {
            const res = await listService.getList('Product Filters', "", "", "", "", "print_location", false);
            this.setState({
                product_filters: res.result.list_type_listing.data
            })
        } catch (e) {
            console.log('Error in listing', e);
        }
    }

    componentDidMount() {
        this.valitdatorList.hideMessages();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.tag !== prevState.tag) {
            // this.props.returnState({
            //     tag: this.state.tag
            // });
        }
    }

    handleSubmitForm(e) {
        e.preventDefault();
        if (this.valitdatorList.allValid()) {
            this.setState(
                {
                    submitted: true
                },
                function () {
                    this.props.returnState({
                        tag: this.state.tag
                    });
                    this.valitdatorList.hideMessages();
                    setTimeout(() => {
                        this.props.handleFormSubmitProp(this.state.tagObject);
                    }, 1000);
                }
            );
        } else {
            this.setState({submitted: false});
            this.valitdatorList.showMessages();
            this.forceUpdate();
        }
    }

    onFilterSelect = (value) => {
        if (!value) {
            this.setState({
                tag: {
                    ...this.state.tag,
                    product_filter_value: value
                }
            })
        } else {
            this.setState({
                tag: {
                    ...this.state.tag,
                    product_filter_value: value.title
                }
            })
        }
    }

    render() {
        const {
            barcode,
            tag_type,
            title,
            description,
            vendor_description,
            status,
            image,
            path,
            allow_quantity_increase,
            product_filter_value
        }
            = this.state.tag;
        const {
            allowedFormatsStringMime,
            allowedFormatsStringExt,
        } = this.state;

        return (
            <form onSubmit={this.handleSubmitForm}>
                <div className="flexElem addCustomer">
                    <div className="mt-md fieldWithIcon">
                        <span className="fieldIcon userIcon"></span>
                        <input
                            type="text"
                            name="title"
                            className="form-control"
                            placeholder="Title"
                            value={title}
                            onChange={this.onChange}
                        />
                        {this.props.requiredField.title && (
                            <span className="customMsg">
                                {this.props.validatorInstance.message(
                                    "Title",
                                    title,
                                    this.props.requiredField.title
                                )}
                            </span>
                        )}
                    </div>
                    <div className="mt-md fieldWithIcon">
                        <div className="col-lg-12" style={{padding: "0px"}}>
                            <Select
                                styles={customSelectStyles}
                                value={HF.returnLabelWithValue(
                                    tag_type,
                                    this.getOptions()
                                )}
                                onChange={this.onBrandChange}
                                options={this.getOptions()}
                                isSearchable={true}
                                name={"tag_type"}
                                isMulti={false}
                                placeholder={"Select Tag Type"}
                                isClearable={false}
                            />
                            <span
                                style={{
                                    textDecoration: "underline",
                                    float: "right",
                                    cursor: "pointer",
                                    color: "blue"
                                }}
                                onClick={this.openAddNewTagForm}
                            >
                                Add New
                            </span>
                        </div>
                        {this.props.requiredField.tag_type && (
                            <span className="customMsg">
                                {this.props.validatorInstance.message(
                                    "tag_type",
                                    tag_type,
                                    this.props.requiredField.tag_type
                                )}
                            </span>
                        )}
                    </div>
                </div>

                <div className="row">
                    <div
                        className="col-md-12"
                        style={{marginBottom: "5px", marginTop: "8px"}}
                    >
                        <span className="fieldIcon userIcon"></span>
                        <input
                            type="text"
                            name="barcode"
                            className="form-control"
                            placeholder="Barcode"
                            value={barcode}
                            onChange={this.onChange}
                        />
                        {/* {this.props.requiredField.barcode && (
                            <span className="customMsg">
                                {this.props.validatorInstance.message(
                                    "Barcode",
                                    barcode,
                                    this.props.requiredField.barcode
                                )}
                            </span>
                        )} */}
                    </div>
                    <div className="col-md-12">
                        <div className="col-md-3" style={{padding: "0px"}}>
                            {image && <ImagePreview filesToPreview={image}/>}
                            {path && !image ? (
                                <div style={{padding: "0px"}}>
                                    <div className="prevImgContainer">
                                        <img
                                            src={process.env.REACT_APP_S3_THUMBNAIL_PATH + path}
                                            width="100%"
                                            onError={e => {
                                                e.target.onerror = null;
                                                e.target.src = defaultImage;
                                            }}
                                            alt={'img'}
                                        />
                                    </div>
                                </div>
                            ) : (
                                !image && (
                                    <div style={{padding: "0px"}}>
                                        <div className="prevImgContainer">
                                            <img
                                                src={defaultImage}
                                                width="100%"
                                                alt='img'
                                            />
                                        </div>
                                    </div>
                                )
                            )}
                        </div>
                        <div className="col-md-9" style={{padding: "0px"}}>
                            <div className="form-group dropzone_profileImage">
                                <FileUpload
                                    files={this.state.tag.image}
                                    setResourceFile={this.setResourceFile}
                                    allowedFormatsStringMimePro={
                                        allowedFormatsStringMime
                                    }
                                    allowedFormatsStringExtPro={
                                        allowedFormatsStringExt
                                    }
                                    multiple={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12" style={{marginBottom: "8px"}}>
                        <textarea
                            name="description"
                            value={description}
                            onChange={this.onChange}
                            cols={40}
                            rows={3}
                            className="form-control"
                            placeholder="Description"
                            maxLength="200"
                        />

                        {this.props.requiredField.description && (
                            <span className="customMsg">
                                {this.props.validatorInstance.message(
                                    "Description",
                                    description,
                                    this.props.requiredField.description
                                )}
                            </span>
                        )}
                    </div>
                    <div className="col-md-12" style={{marginBottom: "8px"}}>
                        <textarea
                            name="vendor_description"
                            value={vendor_description}
                            onChange={this.onChange}
                            cols={40}
                            rows={4}
                            className="form-control"
                            placeholder="Vendor Description"
                            maxLength="200"
                        />

                        {/* {this.props.requiredField.vendor_description && (
                            <span className="customMsg">
                                {this.props.validatorInstance.message(
                                    "Vendor Description",
                                    vendor_description,
                                    this.props.requiredField.vendor_description
                                )}
                            </span>
                        )} */}
                    </div>

                    <div className="col-md-6">
                        <div className="flexElem fieldWithLabel alignFlexCenter">
                            <div>
                                <label>Status</label>
                            </div>

                            <div>
                                <ToggleButton
                                    inactiveLabel={""}
                                    activeLabel={""}
                                    colors={themeCSSConstants.THUMBICONSTYLE}
                                    trackStyle={themeCSSConstants.TRACKSTYLE}
                                    thumbStyle={themeCSSConstants.THUMBSTYLE}
                                    thumbAnimateRange={[4, 30]}
                                    value={status}
                                    onToggle={() =>
                                        this.changeFlag(status, 'status')
                                    }
                                    name="status"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="flexElem fieldWithLabel alignFlexCenter">
                            <div style={{whiteSpace: 'nowrap'}}>
                                <label>Allow Quantity Increase</label>
                            </div>

                            <div>
                                <ToggleButton
                                    inactiveLabel={""}
                                    activeLabel={""}
                                    colors={themeCSSConstants.THUMBICONSTYLE}
                                    trackStyle={themeCSSConstants.TRACKSTYLE}
                                    thumbStyle={themeCSSConstants.THUMBSTYLE}
                                    thumbAnimateRange={[4, 30]}
                                    value={allow_quantity_increase}
                                    onToggle={() =>
                                        this.changeFlag(allow_quantity_increase, 'allow_quantity_increase')
                                    }
                                    name="status"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{paddingTop: '20px'}}>
                    <Select
                        value={HF.returnTitleWithValue(product_filter_value, this.state.product_filters)}
                        onChange={this.onFilterSelect}
                        getOptionLabel={(option) => option.title}
                        getOptionValue={(option) => option.id}
                        options={this.state.product_filters}
                        isSearchable={true}
                        isClearable={true}
                        name={'product_filter_value'}
                        placeholder={'Choose Filter'}
                    />
                </div>
                <div className="row">
                    <div className="col-md-12 mb-xlg">
                        <div className="mt-xlg text-center">
                            <input
                                type="submit"
                                value="Submit"
                                className="customBtn btnBlue"
                            />
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default AddEditTagLayoutForm;



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/Forms/AddEditTagLayoutForm.jsx